import { Skeleton } from '@mui/material';
import cn from 'classnames';
import { DateTime } from 'luxon';
import React from 'react';

import { DAY_NAMES } from './config';

import s from './TaskCalendar.module.scss';

type RenderSkeletonCalendarProps = {
  weeks: DateTime<boolean>[][];
};

const RenderSkeletonCalendar: React.FC<RenderSkeletonCalendarProps> = ({ weeks }) => {
  return (
    <div className={s.calendar}>
      <div className={s.day__names}>
        {DAY_NAMES.map((dayName) => (
          <div
            key={dayName}
            className={cn(s.day__item, {
              [s.day_off]: dayName === 'Сб' || dayName === 'Вс',
            })}
          >
            <p>{dayName}</p>
          </div>
        ))}
      </div>
      <div className={s.calendar__weeks}>
        {weeks.map((week, weekIndex) => (
          <div key={weekIndex} className={s.calendar__week}>
            {week.map((_, dayIndex) => {
              const skeletonCount = Math.floor(Math.random() * 3) + 1;

              return (
                <div key={`skeleton-${weekIndex}-${dayIndex}`} className={s.calendar__day}>
                  {Array.from({ length: skeletonCount }).map((_, i) => (
                    <Skeleton
                      key={i}
                      variant="rounded"
                      height={35}
                      animation="wave"
                      style={{ borderRadius: 8, marginBottom: '5px' }}
                    />
                  ))}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RenderSkeletonCalendar;
